<template>
<div class="container-fluid">
    <!-- <pre>{{device.tags.length}}</pre> -->
    <b-row no-gutters>
        <b-col no-gutters sm=4>
            <b-card no-body border-variant="light">
                <statusdisplay :kkey="'Serial #'" :vvalue="device.serial"></statusdisplay>
                <statusdisplay :kkey="'WAN MAC'" :vvalue="device.mac"></statusdisplay>
                <statusdisplay :kkey="'Model'" :vvalue="device.product.name"></statusdisplay>
                <statusdisplay :kkey="'Hostname'" :vvalue="device.config.system.system[0].hostname"></statusdisplay>
                <statusdisplay :kkey="'Firmware Version:'" :vvalue="device.fw_version"></statusdisplay>
                <!-- <div v-if="device.tags != null">
                    <statusdisplay :kkey="'Additional Info:'" :vvalue="device.tags"></statusdisplay>
                </div> -->
            </b-card>
        </b-col>
        <b-col no-gutters sm=8>
            <b-card no-body border-variant="light">
                <plotconnectsform :serial="device.serial" :deviceID="this.device.id"></plotconnectsform>
            </b-card>
        </b-col>
    </b-row>

</div>
</template>

<script>
import StatusDisplay from '@/readynet/devices/status/StatusDisplay';
import PlotConnectsForm from '@/readynet/devices/graphs/PlotConnectsForm'

export default {
    components: {
        // 'plotconnects': PlotConnects,
        'statusdisplay': StatusDisplay,
        'plotconnectsform': PlotConnectsForm,
    },
    props: {
        device: {
            type: Object,
        },
    },
    data() {
        return {

        }
    },
    methods: {

    },

}
</script>
